import { loadable } from '@elliemae/pui-app-sdk';

export const LoadableAttributionCategoriesView = loadable(
  () =>
    import(
      /* webpackChunkName: "AttributionCategories-view" */ /* webpackPrefetch: true */ './layout/attributionCategories'
    ),
  null, // use wait message from html
);

export default LoadableAttributionCategoriesView;
